import React, {Component} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import fileDownload from "js-file-download";
import {connect} from "react-redux";

class BPContestRow extends Component{
    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }
    render() {
        const {index,item} = this.props;
        return(
            <tr>
                <td>{index+1}</td>
                <td>
                    {item?.bankCode === 'VCB' && <span>Vietcombank</span>}
                    {item?.bankCode === 'AGB' && <span>Agribank</span>}
                </td>
                <td>
                    { this.props.isRoleFWDContest && <Link to={'/bp/contest/'+item.id+'/edit'}>{item?.name}</Link> }
                    { !this.props.isRoleFWDContest && <span>{item?.name}</span> }
                </td>
                <td><button type='button' onClick={() => {
                    this.setState({isLoading: true});
                    axios.get('/api/bankportal/contest/'+item?.id+'/downloadMemo', {responseType: 'blob',})
                        .then((response) => {
                            fileDownload(response.data, item.memoFileName);
                            this.setState({isLoading: false});
                        })
                        .catch(error =>{
                            console.error('There was an error!', error);
                            this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
                        })
                }} className="btn btn-link"><span>Tải Memo</span></button></td>
                <td>{item?.startDate}</td>
                <td>{item?.endDate}</td>
                <td>{item?.closeDate}</td>
                <td>{   item?.status === 'PROCESSING'?'Đang diễn ra':
                        item?.status === 'WAITING_APPROVAL'?'Chờ chốt kết quả':
                        item?.status === 'WAITING_FEEDBACK'?'Chờ phản hồi':
                        item?.status === 'COMPLETED'?'Kết thúc':
                            'Chưa xử lý'}
                </td>
                <td><Link to={'/bp/contest/'+item.id+'/detail'} className={'badge badge-info even-larger-badge'}>Xem chi tiết</Link></td>
            </tr>
        )
    }
}
const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const username = state?.auth?.name;
    return { username,isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO };
};

export default connect(mapStateToProps)(BPContestRow)